import React from "react";

interface AdviceProps {
    title: string,
    questions?: question[],
    templateAnswerResult?: string
    activeTemplate?: boolean
    answerTime?: string
    feedbackAssisstant: Map<string, string>
}

interface question {
    title: string,
    answer: string,
    type: number
}
const InformationTable: React.FC<{ data: AdviceProps }> = ({ data }) => {
    return (
        <div className={"div-section"} style={{marginTop: '48px'}}>
            <table className={"table-information"}>
                <tbody>
                <tr>
                    <td style={{ width: '30%', fontWeight: 'bold', background: '#f9f9f9' }}>氏名</td>
                    <td>{data.questions?.find(item => item.type === 35)?.answer || ''}</td>
                </tr>
                <tr>
                    <td style={{ width: '30%', fontWeight: 'bold', background: '#f9f9f9'  }}>アセスメント受診日</td>
                    <td style={{ padding: '5px' }}>{data.answerTime}</td>
                </tr>
                </tbody>
            </table>
        </div>
    );
};

export default InformationTable;
